import { CursoredPlaylist } from "@mp-commons/modules/playlist/CursoredPlaylist.js";
import { detectWebView } from "@ciaopeople/cp-shatsu/ClientDetection";
import {  MegaridePlayerControlsConfig } from "../MegaridePlayerControlsBaseImpl.js";
import { MegaridePlayerControls, MegaridePlayerGUI } from "../MegaridePlayer.js";
import { AdsController } from "@mp-commons/modules/ads/AdsController.js";
import { UserGestureUnmuter } from "@mp-commons/modules/unmuter/UserGestureUnmuter.js";;
import { PlayerTechFactoryConfig } from "@mp-commons/modules/player/PlayerTechFactory.js";
import { VideoInfoRawData } from "@mp-commons/model/video/VideoInfo.js";



export type PlayerControlsGenerator <PlaylistType extends CursoredPlaylist<VideoInfoRawData>> = (playlist: PlaylistType, 
    gui: MegaridePlayerGUI, controlsConfig: MegaridePlayerControlsConfig, factoryConfig: PlayerTechFactoryConfig, adControllerPromise: Promise<AdsController>, unmuter: UserGestureUnmuter,window: Window) => MegaridePlayerControls;


export function fetchABRStreamingEngine<PlaylistType extends CursoredPlaylist<VideoInfoRawData>>(): Promise<PlayerControlsGenerator<PlaylistType>> {

    const vwDetect = detectWebView()

    if (vwDetect.platform.android) {
        return import(/* webpackChunkName: "DashJsModule" */"./dynamic/DashJsControlsDynModule.js").then(
            res => res.DashJsControlsDynModule
        )
    } else {
        return import(/* webpackChunkName: "VideoJsModule" */"./dynamic/VideoJsControlsDynModule.js").then(
            res => res.VideoJsControlsDynModule
        )
    }

}